import React, { useState, useEffect } from 'react';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: '/images/BannerImages/bannerthree.webp',
      title: 'Anniversary Decoration',
      subtitle: 'Creating Beautiful Spaces Where Love Feels Even More Special',
      buttonText: 'Book Now'
    },
    {
      image: '/images/BannerImages/bannertwo.webp',
      title: 'Turn Your Dream',
      subtitle: 'Decor into Reality',
      buttonText: 'Book Now'
    },
    {
      image: '/images/BannerImages/bannerthree.webp',
      title: 'Beautiful Christmas Decor',
      subtitle: 'for Warm Family Moments',
      buttonText: 'Book Now'
    },
    {
      image: '/images/BannerImages/bannerthree.webp',
      title: 'Special Celebrations',
      subtitle: 'Making Every Moment Memorable',
      buttonText: 'Book Now'
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <section className="relative w-full overflow-hidden py-4 sm:py-6 md:py-8">
      <div className="relative w-full h-[200px] sm:h-[350px] md:h-[400px] lg:h-[450px] sm:max-w-7xl sm:mx-auto px-2 sm:px-4 sm:px-6 lg:px-8">
        {/* Slides Container */}
        <div className="relative w-full h-full rounded-lg overflow-hidden shadow-lg">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                index === currentSlide ? 'opacity-100 z-0' : 'opacity-0 z-0'
              }`}
            >
              <img
                src={slide.image}
                alt={slide.title}
                loading={index === 0 ? "eager" : "lazy"}
                decoding="async"
                className="w-full h-full object-fill sm:object-cover"
              />
            </div>
          ))}
        </div>

        {/* Navigation Arrows - Hidden */}

        {/* Slide Indicators - Bottom center on all screens */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`rounded-full transition-all duration-300 ${
                index === currentSlide
                  ? 'w-8 h-2 bg-white'
                  : 'w-2 h-2 bg-white/60 hover:bg-white/80'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
